<template>
  <div
    ref="panelRef"
    class="flex flex-wrap items-center gap-1.5"
  >
    <slot :is-shrunk />
  </div>
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from 'vue'

import { ResizeObserverEntry, useResizeObserver, useThrottleFn } from '@vueuse/core'

const SHRUNK_WIDTH = 540

const panelRef = useTemplateRef('panelRef')
const isShrunk = ref(false)

useResizeObserver(panelRef, entries => {
  computeShrink(entries[0])
})

const computeShrink = useThrottleFn((entry: ResizeObserverEntry) => {
  isShrunk.value = entry.contentRect.width < SHRUNK_WIDTH
}, 100)
</script>
